var React = require('react');

function ServiceTile1Inline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"25","height":"25","fill":"none","key":0}),React.createElement("path",{"d":"M20,12a8.006,8.006,0,1,1-5.8-7.69l1.57-1.57A9.822,9.822,0,0,0,12,2,10,10,0,1,0,22,12M7.91,10.08,6.5,11.5,11,16,21,6,19.59,4.58,11,13.17Z","transform":"translate(1 1)","fill":"#043250","key":1})]);
}

ServiceTile1Inline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = ServiceTile1Inline;

ServiceTile1Inline.default = ServiceTile1Inline;
